import { GLOBAL_BACK_ICON, MobileBackIcon } from 'src/components/Layout/mobile-page/mobile-page';
import { useLocation } from 'react-router-dom'
import { ADDRESS_FLOW_TYPE, ADDRESS_LIST_FLOW_ROUTE, ADD_ADDRESS_FLOW_ROUTE, ROUTE_PATHS } from 'src/utils/constants'
import { useUploadProductStore } from 'src/store/useUploadProduct/useUploadProductStore';
import { useEffect } from 'react';

export interface SellNavigation {
    backRoute: string;
    icon: MobileBackIcon;
}

const BACK_DEFAULT_NAVIGATION = {
    backRoute:  ROUTE_PATHS.SELL_SCAN_INTRO,
    icon:  GLOBAL_BACK_ICON.CLOSE
}

export const useSellNavigation = (): SellNavigation => {
    const { pathname } = useLocation()
    const formImages = useUploadProductStore(state => state.images)
    const REMOVE_IMAGES = useUploadProductStore(state => state.REMOVE_IMAGES)
    const REMOVE_ALL_FIELDS = useUploadProductStore(state => state.REMOVE_ALL_FIELDS)
    const SYNC_DATA = useUploadProductStore(state => state.SYNC_DATA)

    useEffect(()=>{
        const isFormCreationFlow =
        pathname.includes(ADDRESS_LIST_FLOW_ROUTE.SENDER_ADDRESS_URL) ||
        pathname.includes(ADD_ADDRESS_FLOW_ROUTE[ADDRESS_FLOW_TYPE.SENDER_ADDRESS]) ||
        pathname.includes(`${ROUTE_PATHS.SELL}`) || pathname.includes(ROUTE_PATHS.NICKNAME);
    
      if (!isFormCreationFlow) {
        const hasImages = formImages?.length;
        if (hasImages) {
          REMOVE_ALL_FIELDS()
          REMOVE_IMAGES()
          SYNC_DATA(false)
        }
      }

    },[pathname])


    const sellRoutesBackConfiguration = {
        [ROUTE_PATHS.SELL_RESULTS_SCAN] : {backRoute : ROUTE_PATHS.SELL_SCAN_INTRO, icon: GLOBAL_BACK_ICON.ARROW},
        [ROUTE_PATHS.SELL_RESULTS_SEARCH] : {backRoute : ROUTE_PATHS.SELL_SCAN_INTRO, icon: GLOBAL_BACK_ICON.ARROW},
        [ROUTE_PATHS.SELL_SEARCH_INTRO] : {backRoute : ROUTE_PATHS.SELL_SCAN_INTRO, icon: GLOBAL_BACK_ICON.ARROW},
        [ROUTE_PATHS.SELL_SEARCH_PDP_NEW]: {backRoute : ROUTE_PATHS.SELL_RESULTS_SEARCH, icon: GLOBAL_BACK_ICON.ARROW},
        [ROUTE_PATHS.SELL_SCAN_PDP_NEW]: {backRoute : ROUTE_PATHS.SELL_SCAN_NEW, icon: GLOBAL_BACK_ICON.ARROW},
        [ROUTE_PATHS.SELL_FORM_NEW] :{backRoute : ROUTE_PATHS.PRODUCTS, icon: GLOBAL_BACK_ICON.CLOSE},
        [ROUTE_PATHS.SELL_FORM_EDIT] :{backRoute : ROUTE_PATHS.PRODUCTS, icon: GLOBAL_BACK_ICON.CLOSE},
        [ROUTE_PATHS.SELL_SCAN_INTRO] :{backRoute : ROUTE_PATHS.PRODUCTS, icon: GLOBAL_BACK_ICON.CLOSE},
        [ROUTE_PATHS.SELL_SCAN_NEW] : {backRoute : ROUTE_PATHS.SELL_SCAN_INTRO, icon: GLOBAL_BACK_ICON.ARROW},
    } 

    const getCurrentBackNavigation = (pathname: string, sellRoutesBackConfiguration: any) => {
        const route = Object.entries(sellRoutesBackConfiguration).find(([key]) => pathname.includes(key));
        return route?.length > 0 ? route?.[1] : pathname.includes(`${ROUTE_PATHS.SELL}/`) ? BACK_DEFAULT_NAVIGATION : null;
    }


  return getCurrentBackNavigation(pathname, sellRoutesBackConfiguration) as SellNavigation;
}
